module.exports = __webpack_public_path__ + "img/icon-reservation.b4325cec.png";